import { createRoutine } from 'redux-saga-routines'
import { call, fork, put, takeLatest } from '@redux-saga/core/effects'
import { toast } from 'react-toastify'
import { getApiErrors } from 'utils/errors'
import {
  flagObligation,
  createObligation,
  fetchTaskDomains,
} from 'services/ProgrammeService'

export const flagObligationRoutine = createRoutine('FLAG_OBLIGATION')
export const createObligationRoutine = createRoutine('CREATE_OBLIGATION')
export const fetchTaskDomainsRoutine = createRoutine('FETCH_COMPLIANCE_TASK_DOMAINS')

function* flagObligationSaga({ payload }) {
  const { onSuccess, ...body } = payload || {}
  yield put(flagObligationRoutine.request())
  try {
    const { data } = yield call(flagObligation, body)
    yield put(flagObligationRoutine.success(data?.data))
    toast.success('Thank you. This obligation has been flagged for review.')
    onSuccess?.()
  } catch (error) {
    getApiErrors(error)?.trim() && toast.error(getApiErrors(error))
    yield put(flagObligationRoutine.failure(error))
  }
}

function* createObligationSaga({ payload }) {
  const { onSuccess, ...body } = payload || {}
  yield put(createObligationRoutine.request())
  try {
    const { data } = yield call(createObligation, body)
    yield put(createObligationRoutine.success(data?.data))
    toast.success('Custom obligation added to your organisation’s register.')
    onSuccess?.(data?.data)
  } catch (error) {
    getApiErrors(error)?.trim() && toast.error(getApiErrors(error))
    yield put(createObligationRoutine.failure(error))
  }
}

function* fetchTaskDomainsSaga() {
  yield put(fetchTaskDomainsRoutine.request())
  try {
    const { data } = yield call(fetchTaskDomains)
    yield put(fetchTaskDomainsRoutine.success(data?.data ?? data ?? []))
  } catch (error) {
    getApiErrors(error)?.trim() && toast.error(getApiErrors(error))
    yield put(fetchTaskDomainsRoutine.failure(error))
  }
}

export function* flagObligationWatcher() {
  yield takeLatest(flagObligationRoutine.TRIGGER, flagObligationSaga)
}

export function* createObligationWatcher() {
  yield takeLatest(createObligationRoutine.TRIGGER, createObligationSaga)
}

export function* fetchTaskDomainsWatcher() {
  yield takeLatest(fetchTaskDomainsRoutine.TRIGGER, fetchTaskDomainsSaga)
}

export const complianceSagas = [
  fork(flagObligationWatcher),
  fork(createObligationWatcher),
  fork(fetchTaskDomainsWatcher),
]
